import { render, staticRenderFns } from "./apartments-overview-result.vue?vue&type=template&id=25a4d25f&scoped=true&"
import script from "./apartments-overview-result.ts?vue&type=script&lang=ts&"
export * from "./apartments-overview-result.ts?vue&type=script&lang=ts&"
import style0 from "./apartments-overview-result.scss?vue&type=style&index=0&id=25a4d25f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4d25f",
  null
  
)

export default component.exports